import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Component({
    selector: 'app-lang-switcher',
    templateUrl: './lang-switcher.html',
    styleUrl: 'lang-switcher.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'block' }
})
export class LangSwitcherComponent {
    private readonly document = inject(DOCUMENT);

    currentLang: 'en' | 'es' =
        (this.document.location.pathname.split('/')[1] === 'es') ? 'es' : 'en';

    private stripPrefix(path: string): string {
        const p = path.replace(/^\/(?:(?:en|es)(?=\/|$)\/?)+/, '/');
        return p === '' ? '/' : p;
    }

    href(target: 'en' | 'es') {
        const { pathname, search, hash } = this.document.location;
        return `/${target}${this.stripPrefix(pathname)}${search}${hash}`;
    }

    preventIfActive(e: Event, lang: 'en' | 'es') {
        if (this.currentLang === lang) e.preventDefault();
    }
}
